import {FILTERABLE_PARAM_PREFIX} from '../constants';

/**
 * Removes the "f_" filter prefix
 * from the given string
 * @param {String} filterParam
 */
const stripFilterPrefix = (filterParam = '') =>
  filterParam.split(FILTERABLE_PARAM_PREFIX)?.[1] || filterParam;

export default stripFilterPrefix;
